import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { UtilsService } from './../../services/utils.service';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent implements OnChanges, OnInit {
  @Input() clearFilterButton = false;
  @Input() currentFolder = '';
  @Input() folderColor = '';
  @Input() currentFolderName = '';
  @Input() foldersStructure: {
    name: string;
    id: string;
    color?: string;
    children: any[];
  } = { name: '', id: '', children: [] };
  @Input() folderPath: { level1: string; level2: string[] } = { level1: '', level2: [] }; // Update the input to include level 2 folders
  @Output() buttonClick: EventEmitter<any> = new EventEmitter();
  @Output() clearFilter: EventEmitter<any> = new EventEmitter();

  folderColors: {
    INDEX: string;
    Damages: string;
    ClientUpload: string;
    Discovery: string;
    Liability: string;
    Other: string;
    custom: string;
  };
  folderAliases: any[];
  currentFolderLabel: string;

  constructor(private utils_$: UtilsService) {}

  ngOnInit() {
    // Define folder aliases
    this.folderAliases = [{ name: 'Discs', label: 'Discs files' }];

    // Find the label for the current folder, if it exists in the aliases
    // If it doesn't exist, use the folder name as the label
    this.currentFolderLabel =
      this.folderAliases?.find(f => f.name === this.currentFolderName)?.label || this.currentFolderName;
    // console.log('this.currentFolderLabel: ', this.currentFolderLabel);
  }

  handleClearFilter() {
    this.clearFilter.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentFolderName) {
      this.currentFolderLabel =
        this.folderAliases?.find(f => f.name === this.currentFolderName)?.label || this.currentFolderName;
    }
    // Add this to check the incoming foldersStructure data
    if (changes.foldersStructure) {
      console.log('BreadcrumbComponent received foldersStructure:', this.foldersStructure);
    }
  }

  getButtonStyle(name) {
    return this.utils_$.getButtonStyle(name);
  }

  handleGo(parentFolderId: string) {
    this.buttonClick.emit(parentFolderId);
  }

  // Add this new method to flatten all folders
  getAllFolders(): any[] {
    if (!this.foldersStructure || !this.foldersStructure.children) {
      return [];
    }

    const allFolders: any[] = [];

    const flattenFolders = (folders: any[]) => {
      folders.forEach(folder => {
        // Add this console.log to see each folder and its color

        allFolders.push(folder);
        if (folder.children && folder.children.length > 0) {
          flattenFolders(folder.children);
        }
      });
    };

    flattenFolders(this.foldersStructure.children);
    return allFolders;
  }
}
